<template>
    <div class="container-fluid py-4">
      <div class="row">
        <div class="col-12">
          <div class="multisteps-form mb-9">
            <div class="row">
              <div class="col-12 col-lg-8 m-auto">
                <div class="card">
                  <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                      <p class="ms-3 text-white text-center"><b>Update Passwort für Guest User</b></p>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="p-4">
                      <Form role="form" :validation-schema="schema">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="input-group input-group-static mb-4">
                              <label>Name</label>
                              <input
                                type="text"
                                class="form-control"
                                :value="guest.name"
                                readonly
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="input-group input-group-static mb-4">
                              <label>Email</label>
                              <input
                                type="text"
                                class="form-control"
                                :value="guest.email"
                                readonly
                              />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <div class="input-group input-group-static mb-4">
                              <label>VBot ID</label>
                              <input
                                type="text"
                                class="form-control"
                                :value="guest.vbot_id"
                                readonly
                              />
                            </div>
                          </div>
                        </div>

                        <div class="input-group input-group-static mb-4">
                          <label>Password</label>
                          <Field
                            type="text"
                            class="form-control"
                            v-model="guest.password"
                            name="password"
                            id="password"
                          />
                          <ErrorMessage name="password" class="text-danger" />
                        </div>

                        <Field
                          type="hidden"
                          class="form-control"
                          v-model="guest.id"
                          name="id"
                          id="id"
                        />

                        <div class="button-row d-flex justify-content-end mt-4">
                          <button class="btn btn-sm btn-dark me-2" @click.prevent="createPassword">
                            Create Password
                          </button>
                          <button class="btn btn-sm btn-success" @click.prevent="updatePassword">
                            Update Password
                          </button>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import guestService from "@/services/guest.service";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from 'yup';
import showSwal from "@/mixins/showSwal";

export default {
  name: "EditGuest",
  
  components: {
    Form,
    Field,
    ErrorMessage
  },

  data() {
    return {
      guest: {
        id: null,
        name: '',
        email: '',
        vbot_id: null,
        password: ''
      },
      schema: Yup.object().shape({
        password: Yup.string().required("Password is a required input").min(8, "Password must be at least 8 characters"),
      }),
    };
  },

  methods: {
    async createPassword() {
      try {
        const password = await this.$store.dispatch('guests/createPassword');
        this.guest.password = password;
        showSwal.methods.showSwal({
          type: "success",
          message: `Generated Password: ${password}`,
          width: 500,
          timer: 160000,
          showConfirmButton: true,
        });
      } catch (error) {
        console.error('Error creating password:', error);
        showSwal.methods.showSwal({
          type: "error",
          message: "Failed to generate password",
          width: 500,
        });
      }
    },

    async updatePassword() {
      try {
        if (!this.guest.password || this.guest.password.length < 8) {
          showSwal.methods.showSwal({
            type: "error",
            message: "Password must be at least 8 characters",
            width: 500,
          });
          return;
        }

        const message = await this.$store.dispatch('guests/updatePassword', {
          id: this.guest.id,
          password: this.guest.password,
        });

        showSwal.methods.showSwal({
          type: "success",
          message: message,
          width: 500,
          timer: 3000,
          showConfirmButton: true,
        });
      } catch (error) {
        console.error('Error updating password:', error);
        showSwal.methods.showSwal({
          type: "error",
          message: "Failed to update password",
          width: 500,
        });
      }
    },
  },

  async mounted() {
    const encodedId = this.$route.params.id;
    
    try {
      const guestId = atob(encodedId);
      const guestData = await guestService.getGuestById(guestId);
      
      this.guest = {
        id: guestData.id,
        name: guestData.name,
        email: guestData.email,
        vbot_id: guestData.vbot_id,
        password: ''
      };
    } catch (error) {
      console.error("Error fetching guest data:", error);
      showSwal.methods.showSwal({
        type: "error",
        message: "Failed to load guest data",
        width: 500,
      });
    }
  }
};
</script>

<style scoped>
.btn {
  margin-left: 5px;
}
</style>